import request from '@/utils/request'

// 照片库：后台照片信息--------------------------------------------------------------------------------------
// 查询客户信息翻页
export function photoPage (val) {
  return request({
    url: '/api/aux/admin/photo/page',
    method: 'post',
    data: val.data,
    params: val.params
  })
}

// 收选片角色文档(后台接口)-----------------------------------------------------------------------------
// 添加
export function adminModuleAttributeAdd (val) {
  return request({
    url: '/api/aux/admin/module/attribute/add',
    method: 'post',
    data: val
  })
}
// 删除
export function adminModuleAttributeDel (val) {
  return request({
    url: `/api/aux/admin/module/attribute/del/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取收选片角色列表
export function adminModuleAttributeList (val) {
  return request({
    url: '/api/aux/admin/module/attribute/list',
    method: 'post'
  })
}
// 获取收选片角色分页列表
export function adminModuleAttributePage (val) {
  return request({
    url: '/api/aux/admin/module/attribute/page`',
    method: 'post',
    params: val.params,
    data: val.data
  })
}

// 获取收选片角色详情
export function adminModuleAttributeQueryById (val) {
  return request({
    url: `/api/aux/admin/module/attribute/queryById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑
export function adminModuleAttributeUpdate (val) {
  return request({
    url: '/api/aux/admin/module/attribute/update',
    method: 'put',
    data: val
  })
}

// 后台选片-收片-----------------------------------------------------------------------------------
// 查询选片-收片:列表
export function adminTaskPage (val) {
  return request({
    url: '/api/aux/admin/task/page',
    method: 'post',
    params: val.params,
    data: val.data
  })
}
// 选片-收片:详情
export function adminTaskDetail (val) {
  return request({
    url: `/api/aux/admin/task/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 后台客户信息---------------------------------------------------------------------------------------
// 查询客户信息列表
export function adminCustomerPage (val) {
  return request({
    url: '/api/aux/admin/customer/page',
    method: 'post',
    params: val.params,
    data: val.data
  })
}

// 选片-收片--------------------------------------------------------------------------------------
// 新建选片-收片:信息
export function taskAdd (val) {
  return request({
    url: '/api/aux/task',
    method: 'post',
    data: val
  })
}

// 查询选片-收片:列表
export function taskPage (val) {
  return request({
    url: '/api/aux/task/page',
    method: 'post',
    params: val.params,
    data: val.data
  })
}

// 选片-收片:详情
export function taskDetail (val) {
  return request({
    url: `/api/aux/task/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 编辑选片-收片
export function taskEdit (val) {
  return request({
    url: `/api/aux/task/${val.taskId}`,
    method: 'put',
    data: val.form
  })
}

// 模板主题文档(后台接口)------------------------------------------------------------------------
// 新增
export function themeAdd (val) {
  return request({
    url: '/api/aux/admin/theme/add',
    method: 'post',
    data: val
  })
}
// 编辑主题
export function themeUpdate (val) {
  return request({
    url: '/api/aux/admin/theme/update',
    method: 'put',
    data: val
  })
}

// 删除主题
export function themeDel (val) {
  return request({
    url: `/api/aux/admin/theme/del/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取主题分页列表
export function themeList (val) {
  return request({
    url: '/api/aux/admin/theme/list',
    method: 'post'
  })
}
// 获取主题分页列表
export function themePage (val) {
  return request({
    url: '/api/aux/admin/theme/page',
    method: 'post',
    data: val.vo,
    params: val.params
  })
}

// 收片选片模板文档(后台接口)------------------------------------------------------------------

// SKU管理收选片模板
export function templatePageBySkuId (val) {
  return request({
    url: '/api/aux/admin/template/pageBySkuId',
    method: 'post',
    params: val.params,
    data: val.vo
  })
}

// SKU关联收选片模板
export function skuRelationTemplate (val) {
  return request({
    url: '/api/aux/admin/template/skuRelationTemplate',
    method: 'put',
    data: val
  })
}
// SKU取消关联收选片模板
export function skuRemoveTemplate (idList) {
  return request({
    url: '/api/aux/admin/template/skuRemoveTemplate',
    method: 'post',
    data: idList
  })
}
// 编辑模板主图
export function updateSkuMainImage (val) {
  return request({
    url: '/api/aux/template/updateSkuMainImage',
    method: 'post',
    data: val
  })
}
// 设置默认模板
export function setOrderDefault (id, act) {
  return request({
    url: `/api/aux/admin/template/setOrderDefault/${id}/${act}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查看示例
export function templateGetExample (val) {
  return request({
    url: `/api/aux/admin/template/getExample/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑示例
export function templateSetExample (val) {
  return request({
    url: '/api/aux/admin/template/setExample',
    method: 'put',
    data: val
  })
}
// 设置默认收片模板
export function templateSetCollDefault (val) {
  return request({
    url: `/api/aux/admin/template/setCollDefault/${val}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 设置默认选片模板
export function templateSetPickDefault (val) {
  return request({
    url: `/api/aux/admin/template/setPickDefault/${val}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 新增
export function templateAdd (val) {
  return request({
    url: '/api/aux/admin/template/add',
    method: 'post',
    data: val
  })
}
// 根据模板页查询关联模板
export function getTemplateByModuleId (val) {
  return request({
    url: `/api/aux/admin/module/getTemplateByModuleId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除收片选片模板
export function templateDel (val) {
  return request({
    url: `/api/aux/admin/template/del/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取收片选片模板详情
export function templateQueryById (val) {
  return request({
    url: `/api/aux/admin/template/queryById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑收片选片模板
export function templateUpdate (val) {
  return request({
    url: '/api/aux/admin/template/update',
    method: 'put',
    data: val
  })
}
// 获取收片选片模板分页列表
export function templatePage (val) {
  return request({
    url: '/api/aux/admin/template/page',
    method: 'post',
    params: val.params,
    data: Object.fromEntries(Object.entries(val.vo).map(([key, value]) => [key, value === '' ? null : value]))
  })
}
// 需填信息文档(后台接口)------------------------------------------------------------------------
// 新增
export function moduleInfoAdd (val) {
  return request({
    url: '/api/aux/admin/moduleInfo/add',
    method: 'post',
    data: val
  })
}
// 获取需填信息分页列表
export function moduleInfoPage (val) {
  return request({
    url: '/api/aux/admin/moduleInfo/page',
    method: 'post',
    params: val.params,
    data: val.vo
  })
}
// 编辑需填信息
export function moduleInfoUpdate (val) {
  return request({
    url: '/api/aux/admin/moduleInfo/update',
    method: 'put',
    data: val
  })
}
// 删除需填信息
export function moduleInfoDel (val) {
  return request({
    url: `/api/aux/admin/moduleInfo/del/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 需填信息模块文档(后台接口)------------------------------------------------------------------------
// 新增
export function moduleAdd (val) {
  return request({
    url: '/api/aux/admin/module/add',
    method: 'post',
    data: val
  })
}
// 名称可用
export function moduleCheckName (val) {
  return request({
    url: '/api/aux/admin/module/checkName',
    method: 'put',
    data: val
  })
}
// 删除需填信息模块
export function moduleDel (val) {
  return request({
    url: `/api/aux/admin/module/del/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 编辑需填信息模块
export function moduleUpdate (val) {
  return request({
    url: '/api/aux/admin/module/update',
    method: 'put',
    data: val
  })
}
// 获取需填信息模块分页列表
export function modulePage (val) {
  return request({
    url: '/api/aux/admin/module/page',
    method: 'post',
    params: val.params,
    data: val.vo
  })
}
